/**
 * Frontend 전용 로거 (브라우저 환경)
 * @deprecated `src/observability/logger` 또는 `src/observability` 사용 권장
 * Constitution: Frontend는 Backend Logger를 import하지 않고 이 모듈만 사용.
 * Backend는 infrastructure/logging/Logger.ts 사용.
 */

export interface FrontendLogger {
  debug(message: string, context?: Record<string, unknown>): void;
  info(message: string, context?: Record<string, unknown>): void;
  warn(message: string, context?: Record<string, unknown>): void;
  error(message: string, error?: Error, context?: Record<string, unknown>): void;
}

function formatMessage(
  level: string,
  message: string,
  context?: Record<string, unknown>,
  err?: Error
): void {
  const prefix = `[${level}]`;
  if (context && Object.keys(context).length > 0) {
    console.groupCollapsed(prefix, message);
    console.log('context', context);
    if (err) console.error(err);
    console.groupEnd();
  } else if (err) {
    console.error(prefix, message, err);
  } else {
    switch (level) {
      case 'DEBUG':
        console.debug(prefix, message);
        break;
      case 'INFO':
        console.info(prefix, message);
        break;
      case 'WARN':
        console.warn(prefix, message);
        break;
      case 'ERROR':
        console.error(prefix, message);
        break;
      default:
        console.log(prefix, message);
    }
  }
}

/** Jest/CJS 호환: import.meta 미사용 (parse 단계 SyntaxError 방지) */
function isDevEnv(): boolean {
  if (typeof process !== 'undefined' && process.env.NODE_ENV) {
    return process.env.NODE_ENV === 'development';
  }
  return true;
}

const frontendLogger: FrontendLogger = {
  debug(message: string, context?: Record<string, unknown>) {
    if (!isDevEnv()) return;
    formatMessage('DEBUG', message, context);
  },
  info(message: string, context?: Record<string, unknown>) {
    formatMessage('INFO', message, context);
  },
  warn(message: string, context?: Record<string, unknown>) {
    formatMessage('WARN', message, context);
  },
  error(message: string, error?: Error, context?: Record<string, unknown>) {
    formatMessage('ERROR', message, context, error);
  },
};

export const logger = frontendLogger;
